
<template>
    <div class="PHD">
        <h1 class="page-heading mb-0">Science News Box - Default Example</h1><br/>
        <!-- Dev Instructions: inline data
            This component has 3 props for you to pass data into. 'heading' is a required STRING, while 'description' (also a STRING) and 'link' (OBJECT with 2 strings in it) are optional.

            If either of the optional items are left out, they won't render to the page.

            Here is an example, using JS variable data to fill in the Props, and a random paragraph that takes up the slot space:
        -->
        <science-news-box 
            :heading="demoHeading" 
            :description="demoDescription" 
            :link="demoLink"
            >

            <p>Any single component or content gets slid into a slot here, instead of this paragraph.  Perhaps a placehodler on the Sitecore/.Net side of things?</p>

        </science-news-box>

        <br/><br/><br/>

        <h1 class="page-heading mb-0">Science News Box - Science News Example</h1><br/>
        <!-- Dev Instructions: inline data
            Here is a sample using data the same way as above, but with another vue component inside of it instead of the paragraph:
        -->
        <science-news-box 
            :heading="demoHeading2" 
            :description="demoDescription2" 
            :link="demoLink2"
            >

            <science-news-recent-list></science-news-recent-list>

        </science-news-box>

        <br/><br/><br/>

        <h1 class="page-heading mb-0">Science News Box - Science News Example with inline data</h1><br/>
        <!-- Dev Instructions: inline data
            You can alternatively place your data directly in the vue component, like so:
        -->
        <science-news-box 
            heading="inline title"
            heading-level="1"
            description="inline description" 
            :link="{text: 'inline text', url: 'https://google.com'}"
            >

            <science-news-recent-list></science-news-recent-list>

        </science-news-box>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // example data default
                demoHeading: 'Required Title',
                demoDescription: 'Optional Description',
                demoLink: {
                    text: 'Optional Link',
                    url: 'https://google.com'
                },
                // example data 'Science News'
                demoHeading2: 'Science News',
                demoDescription2: 'Top experts from around the world coming together to discuss and debate the latest cardiovascular science and clinical information',
                demoLink2: {
                    text: 'VIEW ALL NEWS',
                    url: 'https://heart.org'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// demo/components/phd/science-news/demo-science-news-box.vue